'use client'
// =============================================================================
// page-context.store — ce que la page courante SAIT d'elle-même, offert au panneau
// IA de droite (CRM-PROJECT-ERP-MODEL.md §20.23).
//
// Une page de projet y dépose ses FAITS mesurés (jamais une interprétation) et les
// actions qu'elle sait exécuter ; le panneau les lit pour expliquer et proposer.
// Quand la page disparaît, le contexte est retiré : le panneau redevient générique.
// Aucune action ne s'exécute d'elle-même : `run` n'est appelé qu'après la validation
// explicite de l'usager dans le panneau.
// =============================================================================

import { create } from 'zustand'
import type { ProjectFacts, Proposal } from '../src/lib/project-explain'

export interface ProjectContext {
  facts: ProjectFacts
  /** Exécute une action DÉJÀ validée par l'usager (la page recharge ensuite ses faits). */
  run: (id: Proposal['id']) => Promise<void>
  /** Relit les faits auprès du serveur (pour la vérification qui suit une action). */
  refresh: () => Promise<void>
}

/**
 * Le document dont l'« Historique et questions » est ouvert (Bureau › Fichiers › Éditeur). L'historique reste sur la page ;
 * la QUESTION à Ti-Coune se pose dans le panneau IA (onglet Ti-Coune), qui lit ce contexte. Lecture seule : Ti-Coune ne modifie rien.
 */
export interface DocumentContext {
  fileId: string
  name: string
  /** Relit l'historique de la page (une question y est journalisée). */
  refresh: () => void
}

interface PageContextState {
  project: ProjectContext | null
  setProject: (p: ProjectContext | null) => void
  document: DocumentContext | null
  setDocument: (d: DocumentContext | null) => void
}

export const usePageContext = create<PageContextState>((set) => ({
  project: null,
  setProject: (project) => set({ project }),
  document: null,
  setDocument: (document) => set({ document }),
}))
